/**
 * The combination-claim note (figure S1: "combination — no single document
 * asserts this").
 *
 * A combination claim is asserted by no single document — it exists only when
 * two or more are read together. It is the contract's own proof that the Claims
 * lens is not a per-document view with a new label on it: a structure organised
 * by document literally cannot express this claim, because there is no one
 * document to hang it under.
 *
 * Derived from the payload — more than one supporting document id — never from
 * a flag the API does not send.
 */
export default function CombinationClaimBadge() {
  return (
    <span
      data-part="CombinationClaimBadge"
      className="font-semibold text-emerald-700"
      title="Combination claim — no single document asserts this"
    >
      combination — no single document asserts this
    </span>
  )
}
